import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import { IconButton, List, ListItem, ListItemText, Menu, Tooltip, Typography } from '@mui/material';
import React, { type FC } from 'react';

interface PatientLocationMenuProps {
  physicalAddress?: string;
  timeZone?: string;
}
const PatientLocationMenu: FC<PatientLocationMenuProps> = ({ physicalAddress, timeZone }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Tooltip arrow color="primary" placement="bottom" title={'Show patient location details'}>
        <IconButton
          color="inherit"
          aria-label="Show patient location details"
          edge="start"
          sx={{
            mr: 2,
          }}
          id="patient-location-menu-button"
          aria-controls={open ? 'patient-location-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <FmdGoodOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="patient-location-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'patient-location-menu-button',
        }}
      >
        <List sx={{ width: '100%', maxWidth: 300, bgcolor: 'background.paper' }}>
          <ListItem>
            <ListItemText
              primary={physicalAddress}
              secondary={
                <Typography>
                  Address{' '}
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(physicalAddress!)}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    (open map)
                  </a>
                </Typography>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText primary={timeZone} secondary={'Timezone'} />
          </ListItem>
        </List>
      </Menu>
    </>
  );
};

export default PatientLocationMenu;
